// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-settings-control-listing .fi-select-search .mat-mdc-form-field {
  width: 100%;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./Source/app/widget-settings/controls/listing/listing.component.scss"],"names":[],"mappings":"AAEQ;EACI,WAAA;EACA,gBAAA;AADZ","sourcesContent":[".widget-settings-control-listing {\r\n    .fi-select-search {\r\n        .mat-mdc-form-field {\r\n            width: 100%;\r\n            margin-top: 20px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
